import { render, staticRenderFns } from "./v-x-scroll.vue?vue&type=template&id=7f1d982c"
import script from "./v-x-scroll.vue?vue&type=script&lang=js"
export * from "./v-x-scroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f1d982c')) {
      api.createRecord('7f1d982c', component.options)
    } else {
      api.reload('7f1d982c', component.options)
    }
    module.hot.accept("./v-x-scroll.vue?vue&type=template&id=7f1d982c", function () {
      api.rerender('7f1d982c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/scroll/v-x-scroll.vue"
export default component.exports